export interface MangaChapter {
  id: string;
  title: string;
  pages: number;
}

export interface Manga {
  id: string;
  title: string;
  cover: string;
  category: string;
  tags: string[];
  status: "连载中" | "已完结";
  rating: number;
  views: string;
  likes: number;
  authors: string[];
  year: number;
  description: string;
  latestChapter: string;
  chapters: MangaChapter[];
}

export const categories = [
  "全部",
  "热血",
  "恋爱",
  "悬疑",
  "科幻",
  "搞笑",
  "冒险",
  "奇幻",
  "校园",
] as const;

export const mangaList: Manga[] = [
  {
    id: "xinggui-maoxian",
    title: "星轨冒险",
    cover: "https://readdy.ai/api/search-image?query=stylish%20manga%20comic%20cover%20art%20of%20a%20young%20explorer%20with%20a%20glowing%20compass%20among%20floating%20planets%20and%20star%20trails%2C%20warm%20orange%20and%20deep%20blue%20space%20scene%2C%20dynamic%20composition%2C%20vibrant%20anime%20illustration%20with%20clean%20lineart&width=600&height=850&seq=manga-xinggui&orientation=portrait",
    category: "冒险",
    tags: ["星际", "热血", "友情"],
    status: "连载中",
    rating: 9.3,
    views: "2.1亿",
    likes: 428000,
    authors: ["星河绘"],
    year: 2021,
    description: "少年阿星无意间捡到一枚古老的星轨罗盘，却被卷入跨越银河的冒险之中。为了寻找失踪的父亲，他与伙伴们乘坐星舰穿梭于各个星球，对抗黑暗势力，揭开宇宙最深处的秘密。",
    latestChapter: "第 128 话：星海尽头",
    chapters: Array.from({ length: 128 }, (_, i) => ({
      id: `xinggui-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 18 + ((i * 7) % 14),
    })),
  },
  {
    id: "niliu-zhiren",
    title: "逆流之刃",
    cover: "https://readdy.ai/api/search-image?query=epic%20manga%20comic%20cover%20art%20of%20a%20swordsman%20holding%20a%20glowing%20blade%20against%20a%20surging%20waterfall%20of%20flames%2C%20fierce%20battle%20pose%2C%20warm%20crimson%20and%20gold%20toned%20anime%20illustration%2C%20dramatic%20lighting%2C%20dynamic%20action%20scene&width=600&height=850&seq=manga-niliu&orientation=portrait",
    category: "热血",
    tags: ["战斗", "复仇", "成长"],
    status: "连载中",
    rating: 9.6,
    views: "3.8亿",
    likes: 756000,
    authors: ["刃舞"],
    year: 2019,
    description: "武道世家惨遭灭门，唯一幸存者凌夜背负着逆流之刃踏上复仇之路。在腥风血雨的江湖中，他逐渐发现仇人背后隐藏着足以颠覆天下的巨大阴谋。",
    latestChapter: "第 256 话：逆命之剑",
    chapters: Array.from({ length: 256 }, (_, i) => ({
      id: `niliu-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 20 + ((i * 5) % 12),
    })),
  },
  {
    id: "chenxi-lianyu",
    title: "晨曦恋语",
    cover: "https://readdy.ai/api/search-image?query=romantic%20manga%20comic%20cover%20art%20of%20a%20high%20school%20boy%20and%20girl%20under%20cherry%20blossoms%20at%20sunrise%2C%20soft%20warm%20golden%20light%2C%20sweet%20anime%20illustration%2C%20gentle%20expression%2C%20pastel%20and%20warm%20tones&width=600&height=850&seq=manga-chenxi&orientation=portrait",
    category: "恋爱",
    tags: ["校园", "纯爱", "治愈"],
    status: "已完结",
    rating: 9.1,
    views: "1.5亿",
    likes: 302000,
    authors: ["晨雾"],
    year: 2020,
    description: "转学生小葵与新同桌阿澈之间的青涩恋爱物语。从清晨的第一缕阳光开始，两个性格截然不同的人，在平凡的日子里慢慢靠近，写下属于彼此最温柔的晨曦恋语。",
    latestChapter: "全 96 话 完结",
    chapters: Array.from({ length: 96 }, (_, i) => ({
      id: `chenxi-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 16 + ((i * 6) % 12),
    })),
  },
  {
    id: "wuye-zhentanshe",
    title: "午夜侦探社",
    cover: "https://readdy.ai/api/search-image?query=mystery%20manga%20comic%20cover%20art%20of%20a%20detective%20in%20a%20trench%20coat%20holding%20a%20magnifying%20glass%20under%20a%20lone%20street%20lamp%20at%20midnight%2C%20moody%20shadowy%20atmosphere%2C%20dark%20teal%20and%20amber%20toned%20anime%20illustration%2C%20suspenseful&width=600&height=850&seq=manga-wuye&orientation=portrait",
    category: "悬疑",
    tags: ["推理", "烧脑", "惊悚"],
    status: "连载中",
    rating: 9.4,
    views: "2.6亿",
    likes: 519000,
    authors: ["雾隐"],
    year: 2022,
    description: "只在午夜营业的神秘侦探社，接手的都是警方无法破解的离奇案件。社长离夜与助手小满穿梭于黑暗都市，用缜密的推理揭开一个又一个不为人知的真相。",
    latestChapter: "第 88 话：月下谜案",
    chapters: Array.from({ length: 88 }, (_, i) => ({
      id: `wuye-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 22 + ((i * 9) % 14),
    })),
  },
  {
    id: "jixie-jiyuan",
    title: "机械纪元",
    cover: "https://readdy.ai/api/search-image?query=sci-fi%20manga%20comic%20cover%20art%20of%20a%20cyberpunk%20warrior%20in%20armored%20exosuit%20with%20glowing%20energy%20core%20in%20a%20futuristic%20city%2C%20orange%20and%20teal%20neon%20tones%2C%20dynamic%20anime%20illustration%2C%20high%20detail%20mecha&width=600&height=850&seq=manga-jixie&orientation=portrait",
    category: "科幻",
    tags: ["机甲", "末世", "战争"],
    status: "连载中",
    rating: 9.2,
    views: "1.9亿",
    likes: 341000,
    authors: ["钛合金"],
    year: 2023,
    description: "人工智能统治世界的末日，人类最后的希望寄托在能与机甲共鸣的少年身上。当机械纪元拉开序幕，人与机器的界限逐渐模糊，真正的敌人究竟是谁？",
    latestChapter: "第 64 话：觉醒之核",
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: `jixie-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 24 + ((i * 4) % 12),
    })),
  },
  {
    id: "baoxiao-richang",
    title: "爆笑日常",
    cover: "https://readdy.ai/api/search-image?query=comedic%20manga%20comic%20cover%20art%20of%20funny%20cute%20characters%20with%20exaggerated%20happy%20expressions%20surrounded%20by%20household%20items%2C%20bright%20warm%20yellow%20and%20orange%20palette%2C%20playful%20chibi%20style%20anime%20illustration%2C%20lighthearted&width=600&height=850&seq=manga-baoxiao&orientation=portrait",
    category: "搞笑",
    tags: ["日常", "沙雕", "治愈"],
    status: "连载中",
    rating: 8.9,
    views: "3.2亿",
    likes: 688000,
    authors: ["逗逗龙"],
    year: 2020,
    description: "三只性格迥异的合租室友，加上一只会说话的橘猫，每天上演爆笑又暖心的小剧场。没有惊天动地的冒险，只有生活中最真实的欢乐与感动。",
    latestChapter: "第 320 话：猫的报恩",
    chapters: Array.from({ length: 320 }, (_, i) => ({
      id: `baoxiao-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 12 + ((i * 3) % 10),
    })),
  },
  {
    id: "huanjing-zhiLv",
    title: "幻境之旅",
    cover: "https://readdy.ai/api/search-image?query=fantasy%20manga%20comic%20cover%20art%20of%20a%20mage%20with%20a%20glowing%20staff%20standing%20before%20a%20magical%20portal%20into%20a%20dreamlike%20world%2C%20luminous%20warm%20purple%20and%20gold%2C%20whimsical%20anime%20illustration%2C%20enchanted%20forest%20background&width=600&height=850&seq=manga-huanjing&orientation=portrait",
    category: "奇幻",
    tags: ["魔法", "异世界", "冒险"],
    status: "连载中",
    rating: 9.0,
    views: "1.2亿",
    likes: 256000,
    authors: ["梦行者"],
    year: 2021,
    description: "少女小梦意外坠入由梦境编织而成的幻境世界。在这里，想象力就是最强大的魔法。为了找到回家的路，她与同伴们展开了一场奇幻而温柔的旅程。",
    latestChapter: "第 72 话：梦之彼岸",
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `huanjing-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 19 + ((i * 5) % 13),
    })),
  },
  {
    id: "qingchun-zhuanjiao",
    title: "青春转角",
    cover: "https://readdy.ai/api/search-image?query=slice%20of%20life%20manga%20comic%20cover%20art%20of%20high%20school%20students%20walking%20on%20a%20sunlit%20campus%20path%20turning%20at%20a%20corner%2C%20warm%20afternoon%20light%2C%20nostalgic%20sweet%20anime%20illustration%2C%20soft%20pastel%20and%20golden%20tones&width=600&height=850&seq=manga-qingchun&orientation=portrait",
    category: "校园",
    tags: ["青春", "友情", "成长"],
    status: "已完结",
    rating: 8.8,
    views: "9800万",
    likes: 198000,
    authors: ["向阳"],
    year: 2019,
    description: "五个少年少女在青春转角处的相遇与告别。运动会、文化祭、毕业旅行……每一个平凡瞬间，都藏着不平凡的回忆。这是属于每一个人的青春故事。",
    latestChapter: "全 120 话 完结",
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: `qingchun-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 15 + ((i * 7) % 12),
    })),
  },
  {
    id: "duanzui-zhe",
    title: "断罪者",
    cover: "https://readdy.ai/api/search-image?query=dark%20action%20manga%20comic%20cover%20art%20of%20a%20hooded%20vigilante%20with%20chains%20and%20glowing%20red%20eyes%20in%20a%20rainy%20city%2C%20moody%20crimson%20and%20black%20tones%2C%20intense%20anime%20illustration%2C%20dramatic%20shadows&width=600&height=850&seq=manga-duanzui&orientation=portrait",
    category: "热血",
    tags: ["暗黑", "战斗", "复仇"],
    status: "连载中",
    rating: 9.5,
    views: "2.9亿",
    likes: 623000,
    authors: ["墨渊"],
    year: 2020,
    description: "在这个秩序崩坏的都市里，只有断罪者能以暴制暴。背负着不为人知的过去，他以铁链与利刃审判罪恶，却也在黑暗中渐渐迷失自我。",
    latestChapter: "第 173 话：罪与罚",
    chapters: Array.from({ length: 173 }, (_, i) => ({
      id: `duanzui-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 21 + ((i * 6) % 12),
    })),
  },
  {
    id: "xingchen-tushuguan",
    title: "星尘图书馆",
    cover: "https://readdy.ai/api/search-image?query=magical%20manga%20comic%20cover%20art%20of%20a%20librarian%20among%20endless%20floating%20bookshelves%20in%20a%20cosmic%20library%2C%20glowing%20stardust%20and%20warm%20golden%20light%2C%20wonder%20filled%20whimsical%20anime%20illustration&width=600&height=850&seq=manga-xingchen&orientation=portrait",
    category: "奇幻",
    tags: ["治愈", "幻想", "文学"],
    status: "连载中",
    rating: 9.2,
    views: "1.4亿",
    likes: 287000,
    authors: ["拾光"],
    year: 2022,
    description: "在银河尽头的星尘图书馆里，每一本书都封存着一个被遗忘的故事。年轻的图书管理员小星，负责守护这些宇宙的记忆，并在其中找到自己遗失的过去。",
    latestChapter: "第 56 话：遗失的书页",
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: `xingchen-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 18 + ((i * 8) % 12),
    })),
  },
  {
    id: "yuanqi-shitang",
    title: "元气食堂",
    cover: "https://readdy.ai/api/search-image?query=cozy%20manga%20comic%20cover%20art%20of%20a%20chef%20with%20steaming%20delicious%20asian%20food%20dishes%20in%20a%20warm%20restaurant%20kitchen%2C%20appetizing%20warm%20orange%20and%20amber%20tones%2C%20heartwarming%20anime%20illustration&width=600&height=850&seq=manga-yuanqi&orientation=portrait",
    category: "搞笑",
    tags: ["美食", "治愈", "日常"],
    status: "连载中",
    rating: 9.0,
    views: "2.3亿",
    likes: 475000,
    authors: ["小灶"],
    year: 2021,
    description: "开在巷子深处的元气食堂，老板阿灶能用最普通的食材做出抚慰人心的料理。每一位走进食堂的客人，都带着自己的故事，在这里找到温暖与治愈。",
    latestChapter: "第 145 话：深夜的拉面",
    chapters: Array.from({ length: 145 }, (_, i) => ({
      id: `yuanqi-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 14 + ((i * 5) % 12),
    })),
  },
  {
    id: "miwu-zhicheng",
    title: "迷雾之城",
    cover: "https://readdy.ai/api/search-image?query=noir%20mystery%20manga%20comic%20cover%20art%20of%20a%20silhouette%20walking%20through%20a%20foggy%20city%20street%20with%20dim%20lamps%2C%20mysterious%20cool%20teal%20and%20warm%20amber%20tones%2C%20moody%20atmospheric%20anime%20illustration%2C%20suspense&width=600&height=850&seq=manga-miwu&orientation=portrait",
    category: "悬疑",
    tags: ["都市", "黑暗", "谜团"],
    status: "连载中",
    rating: 9.1,
    views: "1.7亿",
    likes: 366000,
    authors: ["迷途"],
    year: 2023,
    description: "终年被迷雾笼罩的城市里，人们一个接一个地神秘失踪。记者苏晚深入调查，却发现这座城市的迷雾背后，藏着一个足以颠覆整个世界的惊人真相。",
    latestChapter: "第 43 话：雾中真相",
    chapters: Array.from({ length: 43 }, (_, i) => ({
      id: `miwu-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 23 + ((i * 7) % 13),
    })),
  },
  {
    id: "chaoshikong-jiuyuandui",
    title: "超时空救援队",
    cover: "https://readdy.ai/api/search-image?query=adventure%20sci-fi%20manga%20comic%20cover%20art%20of%20a%20rescue%20team%20jumping%20through%20a%20glowing%20time%20portal%20with%20gear%20and%20gadgets%2C%20warm%20orange%20and%20teal%20tones%2C%20dynamic%20anime%20illustration%2C%20energetic%20action&width=600&height=850&seq=manga-chaoshikong&orientation=portrait",
    category: "冒险",
    tags: ["时空", "救援", "热血"],
    status: "连载中",
    rating: 8.9,
    views: "1.1亿",
    likes: 214000,
    authors: ["齿轮"],
    year: 2022,
    description: "一支专门穿梭时空、拯救濒危历史的救援队。每当历史轨迹发生偏差，他们便出动修复。直到有一天，他们发现自己也成为了被救援的对象。",
    latestChapter: "第 51 话：时间悖论",
    chapters: Array.from({ length: 51 }, (_, i) => ({
      id: `chaoshikong-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 20 + ((i * 6) % 12),
    })),
  },
  {
    id: "yinghua-xinshi",
    title: "樱花心事",
    cover: "https://readdy.ai/api/search-image?query=sweet%20romance%20manga%20comic%20cover%20art%20of%20a%20girl%20holding%20a%20book%20under%20falling%20sakura%20petals%2C%20gentle%20smile%2C%20soft%20warm%20pink%20and%20golden%20light%2C%20tender%20anime%20illustration%2C%20romantic%20mood&width=600&height=850&seq=manga-yinghua&orientation=portrait",
    category: "恋爱",
    tags: ["校园", "青春", "纯爱"],
    status: "已完结",
    rating: 9.3,
    views: "2.4亿",
    likes: 512000,
    authors: ["樱井"],
    year: 2018,
    description: "樱花盛开的季节，安静的图书委员小樱遇见了总在窗边看书的少年。藏在书页间的心事，像樱花般悄然绽放。这是一段关于暗恋与勇气的温柔故事。",
    latestChapter: "全 88 话 完结",
    chapters: Array.from({ length: 88 }, (_, i) => ({
      id: `yinghua-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 17 + ((i * 5) % 11),
    })),
  },
  {
    id: "long-zhi-qiyue",
    title: "龙之契约",
    cover: "https://readdy.ai/api/search-image?query=epic%20fantasy%20manga%20comic%20cover%20art%20of%20a%20dragon%20and%20a%20young%20knight%20facing%20each%20other%20with%20a%20glowing%20contract%20seal%20between%20them%2C%20majestic%20warm%20crimson%20and%20gold%20tones%2C%20grand%20anime%20illustration%2C%20mythical%20atmosphere&width=600&height=850&seq=manga-longqi&orientation=portrait",
    category: "奇幻",
    tags: ["龙族", "契约", "冒险"],
    status: "连载中",
    rating: 9.4,
    views: "2.7亿",
    likes: 589000,
    authors: ["鳞火"],
    year: 2019,
    description: "在龙与人类共存的古老大陆，最后的龙骑士阿澈与幼龙签订契约，踏上守护这片大陆的征途。随着契约的加深，他也逐渐觉醒了沉睡千年的龙之血脉。",
    latestChapter: "第 201 话：龙焰觉醒",
    chapters: Array.from({ length: 201 }, (_, i) => ({
      id: `longqi-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 22 + ((i * 5) % 14),
    })),
  },
  {
    id: "dianbo-shaonian",
    title: "电波少年",
    cover: "https://readdy.ai/api/search-image?query=quirky%20sci-fi%20manga%20comic%20cover%20art%20of%20a%20teenager%20with%20a%20headphone%20and%20glowing%20antenna%20backpack%20surrounded%20by%20digital%20glitch%20waves%2C%20bright%20warm%20orange%20and%20cyan%20tones%2C%20playful%20anime%20illustration%2C%20whimsical&width=600&height=850&seq=manga-dianbo&orientation=portrait",
    category: "科幻",
    tags: ["科技", "日常", "搞笑"],
    status: "连载中",
    rating: 8.7,
    views: "8600万",
    likes: 165000,
    authors: ["频道"],
    year: 2023,
    description: "能接收奇妙电波信号的少年小电，总能遇到各种匪夷所思的超自然事件。从拯救外星人宠物到破解邻里怪谈，他的日常永远不无聊。",
    latestChapter: "第 39 话：信号风暴",
    chapters: Array.from({ length: 39 }, (_, i) => ({
      id: `dianbo-${i + 1}`,
      title: `第 ${i + 1} 话`,
      pages: 16 + ((i * 9) % 11),
    })),
  },
];

export const siteInfo = {
  name: "漫画网",
  slogan: "让看漫画更顺手",
  description:
    "漫画网是专业的漫画阅读平台，提供漫画翻页模式、漫画横屏阅读、漫画夜间模式，支持漫画缓存下载与漫画阅读设置，让看漫画更顺手。",
  email: "hello@manga.readdy.site",
  phone: "400-888-6666",
  address: "北京市朝阳区星光文创园 8 号楼",
  founded: "2016",
};